module.exports = __webpack_public_path__ + "static/media/designPatent_30-1018452.ff2204ec.png";